import { updateGlobalState } from 'src/actions/Global/globalActions';

export default function updateCurrentEmployeeState(employee) {
  return (dispatch) => dispatch(updateGlobalState({
    currentEmployee: employee.data.data,
  }));
}
